<template>
  <el-dialog
    title="售后工单"
    :visible.sync="visible"
    width="700px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      status-icon
      :model="vendorInfo"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="订单编号:"
        prop="dealOrderCode">
        {{ vendorInfo.dealOrderCode }}
      </el-form-item>
      <el-form-item
        label="备注信息:"
        prop="reason">
        <el-input
          v-model="vendorInfo.reason"
          :autosize="{ minRows: 2, maxRows: 4}"
          type="textarea"
          placeholder="请输入内容">
        </el-input>
      </el-form-item>
      <el-form-item
        label="售后类别:"
        prop="type">
        <el-radio-group v-model="vendorInfo.type">
          <el-radio-button :label="2">退货</el-radio-button>
          <el-radio-button :label="3">换货</el-radio-button>
          <el-radio-button :label="4">补发货</el-radio-button>
          <el-radio-button :label="9">其他</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="图片信息:"
        prop="proofImage">
        <custom-upload-file
          v-model="vendorInfo.proofImage"
          :limit="5"
          accept=".jpg,.png,.pdf" />
      </el-form-item>
      <el-form-item
        v-if="vendorInfo.type !==4 && vendorInfo.type !== 9 "
        label="订单明细:"
        prop="details">
        <el-table
          v-loading="loading"
          max-height="400px"
          :data="vendorInfo.details"
          border>
          <el-table-column
            :resizable="false"
            label="商品名称"
            prop="productName"></el-table-column>
          <el-table-column
            :resizable="false"
            label="商品编码"
            width="80"
            prop="productNumber"></el-table-column>
          <el-table-column
            label="下单数量"
            width="70"
            :resizable="false"
            prop="num">
            <template slot-scope="{row}">{{ row.num }} {{ row.measureUnit | measureUnitName() }}</template>
          </el-table-column>
          <el-table-column
            label="退货数量"
            :resizable="false"
            prop="goodsCount">
            <template slot-scope="{row,$index}">
              <el-form-item
                style="margin-bottom:0"
                label-width="0"
                :prop="'details.' + $index + '.goodsCount'">
                <el-input-number
                  v-model="vendorInfo.details[$index].goodsCount"
                  style="width: 100%"
                  :precision="0"
                  :max="row.outNum"
                  :min="0"></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import UploadImage from '@/components/public/upload-image-new.vue'
import CustomUploadFile from '@/components/public/custom-upload-file.vue'
export default {
  name: 'AfterSalesModal',
  components: { CustomUploadFile },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      vendorInfo: {
        dealOrderCode: '',
        reason: '',
        proofImage: [],
        type: 2,
        details: []
      },
      rules: {
        reason: [
          { required: true, message: '请输入备注信息', trigger: 'blur' }
        ],
        // proofImage: [
        //   { required: true, message: '请上传图片信息', trigger: 'change' }
        // ],
        type: [
          { required: true, message: '请选择售后类别', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.vendorInfo = {
        dealOrderCode: '',
        reason: '',
        proofImage: [],
        type: 2,
        details: []
      }
      this.$refs.ruleForm.resetFields()
    },
    init(info) {
      this.toggleModal(true)
      this.vendorInfo = {
        ...this.vendorInfo,
        // ...info,
        id: info.id,
        dealOrderCode: info.code,
        details: info.detailList.map(i => {
          return {
            productId: i.skuId,
            productNumber: i.skuCode,
            goodsCount: 0,
            returnedGoodsCount: 0,
            productName: i.skuName,
            num: i.num,
            measureUnit: i.measureUnit
          }
        })
      }
      // this.vendorInfo.salesOrderId = info.id
      // this.vendorInfo.dealOrderCode = info.code
      // this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId: this.vendorInfo.salesOrderId
        },
        success: res => {
          this.loading = false
          this.vendorInfo.details = res.data.data.detailList.map(i => {
            return {
              productId: i.skuId,
              productNumber: i.skuCode,
              goodsCount: 0,
              returnedGoodsCount: 0,
              productName: i.skuName,
              num: i.num,
              measureUnit: i.measureUnit
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.vendorInfo.details.every(i => i.goodsCount === 0) && this.vendorInfo.type !== 4 && this.vendorInfo.type !== 9) {
            this.$message.error('退货数量不能为0')
            return
          }
          this.loading = true
          this.$store.dispatch('goodsreturn/addpostsaleorder', {
            payload: {
              ...this.vendorInfo,
              status: this.vendorInfo.type === 9 ? 2 : null,
              proofImage: this.vendorInfo.proofImage.map(item => item.url).join(','),
              details: this.vendorInfo.type === 4 ? null : this.vendorInfo.details.filter(i => i.goodsCount > 0)
            },
            success: () => {
              this.loading = false
              this.callback && this.callback()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
